
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import StepList from "@/components/scope/step-list.vue";
import dayjs from "dayjs";
import { priceRulesEl } from "@common/src/utils/verify";
import ReturnCard from "./components/return-card.vue";
import { addCurrencyUnit } from "@common/src/utils/tools";
import PartsGroupPreview from "@common/src/views/setting/components/parts-group-preview.vue";
import t from "@common/src/i18n/t";

const marketing = namespace("marketing");
const setting = namespace("setting");
const base = namespace("base");

@Component({
  components: {
    StepList,
    ReturnCard,
    PartsGroupPreview
  }
})
export default class PurchaseView extends Vue {
  @marketing.Action queryCardDetail;
  @marketing.Action delayCardValidityPeriod;
  @setting.Action getPatternPaymentList;
  @marketing.Action updateCardStatusRefund;
  @base.Action jumpPrintPage;
  dayjs = dayjs;
  splitThousands = splitThousands;
  addCurrencyUnit = addCurrencyUnit;
  emptyToLine = emptyToLine;
  get breadData() {
    return [{ name: t("marketing.card-manage"), path: "/marketing/card" }, { name: t("v210901.card-details") }];
  }
  paymentData: any = {};
  payWayList: any = [];
  created() {
    this.init();
  }
  get orderId() {
    return this.$route.params.id;
  }
  detailData: any = {
    operateList: []
  };
  refundLoading: boolean = false;
  groupIndex: number = 1;
  init(refreshLog = false) {
    this.queryCardDetail({
      cardCode: this.orderId
    }).then(data => {
      data = data?.data || {};
      if (refreshLog) {
        this.detailData.operateList = data.operateList || [];
      } else {
        if (data.cardType === 1) {
          data.serviceList &&
            data.serviceList.forEach(serviceItem => {
              if (serviceItem.partsList && serviceItem.partsList.length > 0) {
                serviceItem.isGroup = true;
                serviceItem.groupServiceIndex = this.groupIndex;
                serviceItem.partsList.forEach(partsItem => {
                  data.partsList.push(
                    Object.assign(partsItem, {
                      isGroup: true,
                      groupServiceIndex: this.groupIndex
                    })
                  );
                });
                this.groupIndex++;
              }
            });
        }
        this.detailData = data;
      }
    });
    this.getPatternPaymentList({
      status: "1"
    }).then(data => {
      this.payWayList = this.$safeValue(data, "data", []);
    });
  }
  showRefundModal: boolean = false;
  refundForm: any = {
    cardCode: "",
    returnAmount: "0",
    returnMethod: "",
    returnRemark: ""
  };
  refundFormRule: any = {
    returnAmount: [
      { required: true, message: t("v210906.please-enter-the-actual-refund-amount"), trigger: "blur" },
      { validator: this.checkPrice, trigger: "blur" }
    ],
    returnRemark: { required: true, message: t("v210831.please-enter-refund"), trigger: "blur" },
    returnMethod: { required: true, message: t("finance.select-mode-payment"), trigger: "change" }
  };
  checkPrice(rule, value, callback) {
    priceRulesEl(value, callback);
  }
  recommendReturnAmount: string = "";
  handleShowRefund() {
    const refs = this.$refs.returnCard as any;
    refs.showRefundModalFn();
    this.showRefundModal = true;
    if (Number(this.detailData.cardAmount) > 0 && Number(this.detailData.carryingAmount) > 0) {
      this.refundForm.returnAmount = this.recommendReturnAmount = (
        this.detailData.carryingBalance *
        (this.detailData.cardAmount / this.detailData.carryingAmount) *
        0.8
      ).toFixed(2);
    } else if (Number(this.detailData.carryingAmount) === 0) {
      // 账面金额为0
      this.refundForm.returnAmount = this.recommendReturnAmount = "";
    } else {
      this.refundForm.returnAmount = this.recommendReturnAmount = "0.00";
    }
    this.refundForm.cardCode = this.orderId;
  }
  handleconfirmRefund() {
    this.init();
    this.showRefundModal = false;
  }
  handleOpenOrder(row) {
    let param = `serviceItemCodes=${row.serviceCode}`;
    const { href } = this.$router.resolve(
      `/service/add?type=${row.serviceClass === 2 ? "wash" : "maintenance"}&${param}&customerCode=${
        this.detailData.customerCode
      }`
    );
    window.open(href);
  }
  handlePartsOpenOrder(command, row) {
    let param = `partsCodes=${row.partsCode}`;
    let url = "";
    if (command === "maintenance") {
      url = this.$router.resolve(
        `/service/add?type=${row.serviceClass === 2 ? "wash" : "maintenance"}&${param}&customerCode=${
          this.detailData.customerCode
        }`
      ).href;
    } else {
      url = this.$router.resolve(`/service/add?type=retail&${param}&customerCode=${this.detailData.customerCode}`).href;
    }
    window.open(url);
  }
  handleRefresh() {
    this.init(true);
    this.$message.success(t("v212.refreshed"));
  }
  handleLinkSetNotice() {
    this.$router.push({
      name: "marketingCard",
      params: {
        showNoticeChannelSet: "1"
      }
    });
  }
  handleLinkCharge() {
    let { href } = this.$router.resolve(`/marketing/message-recharge`);
    window.open(href);
  }
  showPartsGroupPreview = false;
  partsRuleCode = "";
  partsRuleType = 2;
  groupName = "";
  handleGroupDetail(row) {
    this.showPartsGroupPreview = true;
    this.partsRuleCode = row.partsCode;
    this.partsRuleType = row.partsRuleType;
    this.groupName = row.partsName;
  }
  handleDelay() {
    this.$confirm(t("v216_6.card-period-tips"), t("v210831.tips"), {
      confirmButtonText: t("v210831.determine"),
      cancelButtonText: t("base.cancel"),
      type: "warning"
    })
      .then(() => {
        this.delayCardValidityPeriod({
          customerCode: this.detailData.customerCode,
          cardCode: this.detailData.cardCode
        }).then(() => {
          this.$message.success(t("v216_6.card-period-been-extended"));
          this.init();
        });
      })
      .catch(() => {
        //
      });
  }
  handlePrint() {
    this.jumpPrintPage({
      category: "PRINT_CARD_DETAIL",
      documentNo: this.detailData.cardCode
    });
  }
  handlePrintConsumption(consumptionItem) {
    this.jumpPrintPage({
      category: "PRINT_CARD_CONSUMPTION",
      documentNo: this.detailData.cardCode + ":" + consumptionItem.orderCode
    });
  }
}
